// extracted by mini-css-extract-plugin
export default {"popperContainer":"styles_popperContainer__BmK1G"};